module.exports = __webpack_public_path__ + "static/media/OSMB05.8320d9b6.jpg";